export function BailOut(message) {
  this.name = 'BailOut'
  this.message = message
  this.stack = new Error().stack
}

BailOut.prototype = Object.create(Error.prototype)
BailOut.prototype.constructor = BailOut
